import { register } from "../registry";
import { FallbackRenderer } from "./FallbackRenderer";
import { NumberRenderer } from "./NumberRenderer";
import { BooleanRenderer } from "./BooleanRenderer";
import { StatusRenderer } from "./StatusRenderer";
import { DateRenderer } from "./DateRenderer";
import { UrlRenderer } from "./UrlRenderer";
import { ImageRenderer } from "./ImageRenderer";
import { AddressRenderer } from "./AddressRenderer";
import { ChainRenderer } from "./ChainRenderer";
import { TokenAmountRenderer } from "./TokenAmountRenderer";
import { MarkdownRenderer } from "./MarkdownRenderer";
import { SlackMrkdwnRenderer } from "./SlackMrkdwnRenderer";
import { TelegramHtmlRenderer } from "./TelegramHtmlRenderer";
import { CodeRenderer } from "./CodeRenderer";
import { TableRenderer } from "./TableRenderer";
import { StatGroupRenderer } from "./StatGroupRenderer";

let registered = false;

/** Registers every renderer exactly once. Called by AutoResultView on mount and
 *  by tests that need the real registry populated. Tests that call
 *  clearRegistry() must also call _resetRegisteredForTest() before re-invoking. */
export function registerAllRenderers(): void {
  if (registered) return;
  registered = true;
  // Order matters only for ties; priority bands do the real ordering.
  register(FallbackRenderer);
  register(NumberRenderer);
  register(BooleanRenderer);
  register(StatusRenderer);
  register(DateRenderer);
  register(UrlRenderer);
  register(ImageRenderer);
  register(AddressRenderer);
  register(ChainRenderer);
  register(TokenAmountRenderer);
  register(MarkdownRenderer);
  register(SlackMrkdwnRenderer);
  register(TelegramHtmlRenderer);
  register(CodeRenderer);
  register(TableRenderer);
  register(StatGroupRenderer);
}

/** Test-only: resets the once-guard so a test doing clearRegistry() +
 *  registerAllRenderers() actually re-registers. Not for production use. */
export function _resetRegisteredForTest(): void {
  registered = false;
}
